module.exports = __webpack_public_path__ + "static/medical-79c7e9b262d450fd85dbeab62d189d91.jpg";